"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertBadHttpStatus = assertBadHttpStatus;
var _shared = require("@cian/peperrors/shared");
function assertBadHttpStatus(response) {
  if (response.statusCode === 200) {
    return;
  }
  throw new _shared.HttpBadStatusCodeError({
    domain: 'src/services/assert/assertBadHttpStatus',
    message: 'Reliability HttpBadStatusCodeError',
    statusCode: response.statusCode
  });
}